import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const TooltipComponent = React.lazy(() => import("../Components/RootComponents/TooltipComponent"));
const TooltipPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <TooltipComponent />
      </Suspense>
    </Fragment>
  );
};

export default TooltipPage;
